// extracted by mini-css-extract-plugin
export default {"nested":"MenuDrawer_nested__6V+Xo","menu-list":"MenuDrawer_menu-list__5zsqD"};